export default __webpack_public_path__ + "static/media/yosemite-slab-crop.39af797e.jpg";